import React from 'react'
import { Route, useRouteMatch } from 'react-router'
import { positionDefault } from '@reach/popover'

import { NavbarFilterProps } from 'components/Navbar'
import { SelectInput, SelectTriggerUnstyled } from 'components/Select'
import {
  useGetDocumentListSettingsQuery,
  WorkspaceMinimalFragment,
} from '@sketch/gql-types'
import {
  Filter,
  IconWrapper,
  StyledCheckbox,
  StyledChevron,
  StyledSelectPopover,
  ToggleWrapper,
  StyledDropdownItem,
} from './SearchBar.styles'
import { Tooltip, TooltipShortcut, Dropdown } from '@sketch/components'
import { routes } from '@sketch/constants'

export interface SearchBarProps {
  onSearchChange?: NonNullable<NavbarFilterProps['onChange']>
  search?: NavbarFilterProps['value']
  userRole: WorkspaceMinimalFragment['userRole']
}

const getPlaceholderByPath = (path: string) => {
  switch (path) {
    case routes.WORKSPACE_TRASH.template():
      return 'Search all documents in Trash'
    case routes.WORKSPACE_LIBRARIES.template():
    case routes.DESIGN_SYSTEM.template():
      return 'Search Libraries'
    case routes.WORKSPACE_SHARED_WITH_ME.template():
      return 'Search Shared with Me'
    case routes.WORKSPACE_TEMPLATES.template():
      return 'Search Templates'
    case routes.WORKSPACE_DRAFTS.template():
      return 'Search My Drafts'
    default:
      return 'Search'
  }
}

export const SearchBar = ({
  onSearchChange,
  search,
  userRole,
}: SearchBarProps) => {
  const { data, updateQuery } = useGetDocumentListSettingsQuery()
  const { showDocumentsInProjects } = data || {}

  const shouldShowSearchOptions = userRole !== 'GUEST'

  const { path } = useRouteMatch()
  const inputPlaceholder = getPlaceholderByPath(path)

  return (
    <Tooltip
      content={
        <>
          Search
          <TooltipShortcut>Press /</TooltipShortcut>
        </>
      }
      disableWhenTouchDevice
      placement="bottom-start"
    >
      <Filter
        onChange={onSearchChange}
        value={search}
        name="search"
        placeholder={inputPlaceholder}
      >
        <Route path={routes.WORKSPACE_SHARES.template()}>
          {shouldShowSearchOptions && (
            <SelectInput value={'Options'}>
              <SelectTriggerUnstyled>
                <ToggleWrapper>
                  Options
                  <IconWrapper>
                    <StyledChevron />
                  </IconWrapper>
                </ToggleWrapper>
              </SelectTriggerUnstyled>
              <StyledSelectPopover position={positionDefault}>
                <Dropdown.Header>Show Documents</Dropdown.Header>
                <StyledDropdownItem>
                  <StyledCheckbox
                    checked={showDocumentsInProjects}
                    label="Include documents in Projects"
                    onChange={event =>
                      updateQuery(previous => ({
                        ...previous,
                        showDocumentsInProjects: !showDocumentsInProjects,
                      }))
                    }
                  />
                </StyledDropdownItem>
                {/* Reset is hidden for now until we don't have more search options to reset */}
                {/* <Dropdown.Divider />
            <StyledDropdownResetItem
              disabled={includeDocsInProjects === true}
              onClick={() => onIncludeDocsInProjectsChange(true)}>
              <StyledResetIcon disabled={includeDocsInProjects === true} />{' '}
              Reset
            </StyledDropdownResetItem> */}
              </StyledSelectPopover>
            </SelectInput>
          )}
        </Route>
      </Filter>
    </Tooltip>
  )
}
